import { AppState } from '../types'

export function updateCookies(state: AppState) {
  if (!state.user) return
}
